import { gql } from "graphql-request";

export const FIELD_REQUEST_FRAGMENT = gql`
  fragment FieldRequestFragment on FieldRequestType {
    id
    type
    field
    displayName
    displayText
    required
    isSubmitted
    subtitle
    isCollectedByLender
    submittedData
    lenderComment
  }
`;
